import React from "react";
import { SITE } from "@/data/content";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer"
            className="relative bg-black border-t border-white/10"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
                <div className="grid grid-cols-12 gap-8 items-start">
                    <div className="col-span-12 md:col-span-6">
                        <img
                            src="/brand/ssppl-logo.png"
                            alt="Studio Shakthi"
                            className="h-[3.6rem] w-auto object-contain"
                        />
                        <p className="mt-6 text-[hsl(var(--text-secondary))] text-sm leading-relaxed max-w-md">
                            {SITE.tagline} — a production house engineering emotion-led
                            cinema for a global audience.
                        </p>
                    </div>
                    <div className="col-span-6 md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--text-muted))] mb-4">
                            Navigate
                        </div>
                        <ul className="space-y-2.5">
                            {[
                                ["About", "#about"],
                                ["Team", "#team"],
                                ["Projects", "#projects"],
                                ["Capabilities", "#capabilities"],
                                ["Contact", "#contact"],
                            ].map(([l, h]) => (
                                <li key={h}>
                                    <a
                                        href={h}
                                        data-testid={`footer-link-${h.slice(1)}`}
                                        className="cine-underline text-[hsl(var(--text-secondary))] hover:text-white text-sm"
                                    >
                                        {l}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-span-6 md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--text-muted))] mb-4">
                            Contact
                        </div>
                        <a
                            href={`mailto:${SITE.contactEmail}`}
                            className="cine-underline text-white text-sm"
                            data-testid="footer-email"
                        >
                            {SITE.contactEmail}
                        </a>
                        <div className="mt-3 text-[hsl(var(--text-secondary))] text-sm">
                            {SITE.locationHQ}
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--text-muted))]">
                        © {year} {SITE.name}. All rights reserved.
                    </div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--text-muted))]">
                        Crafted with restraint — Chennai
                    </div>
                </div>
            </div>
        </footer>
    );
};
